import React, {useState, useEffect, Fragment} from 'react';
import TextField from '@material-ui/core/TextField';
import {Section, Popup, List, Loader, Explanation_text, GridList, Warning_box, Credit_price} from '../../../components';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import {useTheme} from "@material-ui/core";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import SearchIcon from '@material-ui/icons/Search';
import BackIcon from '@material-ui/icons/ArrowBack';
import axios from 'axios';
import {connect} from 'react-redux';

function Confirmation_required(props){
  const [confirm_these, setConfirmThese]=useState(undefined);
  const [gps_confirm_these, setConfirmTheseGPS]=useState('start');
  const [checkboxes, setCheckboxes]=useState([]);
  const [secondary_checkboxes, setSecondaryCheckboxes]=useState([]);
  const [gps_checkboxes, gps_setCheckboxes]=useState([]);
  const [remaining_prospects, setRemainingProspects]=useState(undefined);
  const [scrape_websites, setScrapeWebsites]=useState(undefined);
  const [list_id, setListId]=useState(undefined);
  const[search, setSearch]=useState('');
  const[max_results, setMaxResults]=useState(200);
  const[current_batch_data, setCurrentBatchData]=useState(undefined);
  const[current_batch, setCurrentBatch]=useState(undefined);
  const[preview_batch_id, setPreviewBatchId]=useState(undefined);
  const[batch_wait_notice, setBatchWaitNotice]=useState(false);
  const[topup_url, setTopupUrl]=useState(undefined);
  const[topups_required, setTopupsRequired]=useState(undefined);
  const[existing_companies, setExistingCompanies]=useState(undefined);
  const[confirm_duplicates, setConfirmDuplicates]=useState(undefined);
  const[duplicates_popup, setDuplicatesPopup]=useState(undefined);
  const theme=useTheme();
  let previews=props.search_previews;

  if(props.search_batch_id!=undefined && preview_batch_id==undefined){setPreviewBatchId(props.search_batch_id);}

  if(confirm_these==undefined && props.workspace_data!=undefined && props.workspace_data.previews!=undefined){
    setConfirmThese(props.workspace_data.previews);
  }
  function reviewGPSCompanies(){
    axios.get('/api/companies/confirmation/required/gps').then((data)=>{
      setConfirmTheseGPS(data.data);
      gps_setCheckboxes([]);
    })
  }

  function gps_submit(){
    let gps_checks=[];
    for(let gps of gps_checkboxes){gps_checks.push({id:Number(gps.split('_')[0]), match_id:Number(gps.split('_')[1])})}
    axios.post('/api/companies/confirmation/required/gps', {confirmed:gps_checks}).then((data)=>{
      window.location.reload();
    });
  }

  if(preview_batch_id!=undefined && (search=='' || search==undefined)){for(let cp of props.workspace_data.confirmations_pending){if(cp.id==preview_batch_id){setSearch(cp.name); setListId(cp.list_id); break;}}}

  if(props.search_name!=undefined && (search=='' || search==undefined)){setSearch(props.search_name); setListId(props.list_id);}


  useEffect(()=>{
    if(props.lists==undefined){props.index_lists();}
    for(let cp of props.workspace_data.confirmations_pending){if(cp.preview==true){setSearch(cp.name); setListId(cp.list_id); props.getPreview(cp.id); break;}}
    reviewGPSCompanies();
},[])

  let gps_list=[];
  if(gps_confirm_these!=undefined && gps_confirm_these!='loading' && gps_confirm_these!='start'){
    for(let ct of gps_confirm_these){
      for(let m of ct.matches){
        gps_list.push({id:ct.id+'_'+m.id, main_text:'New: '+ct.name+' - Address: '+ct.address, secondary_text:'Close to: '+m.name+' - Address: '+m.address});
    }}
  }

  function reviewCompanies(id){ //FIND ALL COMPANIES NEEDING CONFIRMATION FOR THIS BATCH ONLY;
    setCurrentBatch(id);
    setDuplicatesPopup(undefined);
    setConfirmThese('loading');
    axios.get('/api/uploads/batches/show/'+id).then((data)=>{
      setConfirmThese(data.data);
      let new_checks=[]; for(let c of data.data){new_checks.push(c.id);} setCheckboxes(new_checks); setSecondaryCheckboxes(new_checks);
      if(new_checks.length==0){submit(id);}
    })
  }


  function reviewDuplicates(x, skip_existing=false){
    console.log(x, 'X HERE');
    setCurrentBatchData(x);
    if(x.existing_companies>0 && skip_existing==false && x.existing_companies_done!=true){
      setDuplicatesPopup(x);
      axios.get('/api/uploads/batches/showDuplicates/'+x.id).then((data)=>{
        console.log(data, 'Y HERE');
        let df=[]; for(let d of data.data){df.push({id:d.id, main_text:d.name, secondary_text:"Website: "+d.website+" - City: "+d.city});}
        setExistingCompanies(df);
      })
    }else if((x.repeated_contacts>0 || x.empty_contacts>0) && x.type==1){
      setDuplicatesPopup(x);
      setExistingCompanies(undefined);
      axios.get('/api/uploads/batches/showContactWarnings/'+x.id).then((data)=>{
        console.log(data, 'Z HERE');
        let df=[]; for(let id of data.data){let rows='Rows: '; for(let i of id){rows=rows+' - '+i} df.push({id:id, main_text:rows});}
        setConfirmDuplicates(df);
      })
    }else{reviewCompanies(x.id);}
  }

  function listMoveDecision(x, move){
    axios.post('/api/uploads/batches/moveDuplicates', {prospect_batch_id:x.id, move_list:move}).then((data)=>{
      reviewDuplicates(x, true);
    })
  }

  let list=[];
  if(confirm_these!=undefined && confirm_these!='loading'){
    for(let ct of confirm_these){let done=false;
      if(done==false){list.push({id:ct.id, main_text:ct.name, secondary_text:"Website: "+ct.website+" - City: "+ct.city});
    }}
  }

  function submitSearch(id){
    props.automatedSearch({prospect_batch_id:id, search:search, max_results:max_results, preview:false, list_id:list_id})
  }

  function cancelSearch(){
    axios.post('/api/cancel_search').then((data)=>{
      window.location.reload();
    })
  }

  function cancel(id){props.setLoader(true); axios.post('/api/uploads/batches/abort/'+id).then((data)=>{window.location.reload();}).catch((error)=>{props.setLoader(false);})}




  function submit(id){props.setLoader(true);
    axios.post('/api/uploads/batches/confirm/'+id, {prospect_batch_id:id, confirmed:checkboxes, scrape_websites:secondary_checkboxes}).then((data)=>{props.setLoader();
      if(data.data.error!=undefined){
        setRemainingProspects(data.data.remaining_prospects);
        setTopupUrl(data.data.topup_url);
        setTopupsRequired(data.data.topups_required);
      }else{
        let f={list_ids:[data.data.list_id], list_meta:'LIST_SELECTION'};
       let has_prl=false; for(let css of props.workspace.customer_of_special_services){let ds=css.workspace_default_special_service; if(ds.rec=='SCORING' && css.push_service==true){has_prl=true;}}
       f=encodeURIComponent(btoa(JSON.stringify(f))); let prl_special=''; if(has_prl==true && (data.data.prospect_batch==undefined || data.data.prospect_batch.type==1)){prl_special='?send_to_prl=open';} window.location.href='/companies/table/f/'+f+prl_special;
     }
    }).catch((error)=>{props.setLoader(false);});
  }




  if(scrape_websites==undefined && props.workspace!=undefined){setScrapeWebsites((props.workspace.scrape_websites==true)?true:false);}

  //let storage_cost=2;
  let website_cost=0;
  let credit_cost=0
  if(confirm_these!=undefined && confirm_these!='loading'){
    for(let ct of confirm_these){
      //if(checkboxes.includes(ct.id) && ct.origin=='AUTOMATED_SEARCH'){credit_cost+=storage_cost;}
      if(secondary_checkboxes.includes(ct.id)==true && ct.website!=null){credit_cost+=website_cost;}
    }
  }

  function trySearchAgain(id){axios.post('/api/uploads/batches/abort/'+id).then((data)=>{window.location.href='/companies/table?open_popup=true';});}

  let credit_cost_text="";
  if(checkboxes.length!=0 && confirm_these!=undefined){credit_cost_text=" - "+credit_cost+" credits"}
  if(gps_confirm_these=='start'){return(null)}
  else if(gps_confirm_these!=undefined && gps_confirm_these.length!=0){
          return(
            <Section>
              {(gps_confirm_these=='loading')?
                <div style={{height:'400px', width:'100%', position:'relative'}}><Loader embed/></div>
              :
                <Fragment>
                  <Typography style={{marginBottom:'20px', textAlign:'center', width:'100%'}}>{"Alert: locations less than "+props.workspace.longitude_latitude_wide_deduplication+" metres apart. Select any duplicates."}</Typography>
                  <div style={{height:'400px', width:'calc(100% + 40px)', marginLeft:'-20px', position:'relative'}}>
                        <List background_colour='rgba(255,255,255,1)' small_text list_data={gps_list} onClick={(x)=>{console.log(x);}} checkboxes={gps_checkboxes} onChange={(x)=>{gps_setCheckboxes(x);}}/>
                  </div>
                  <div style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center', marginTop:'40px'}}><Button variant='contained' color='secondary' onClick={()=>{gps_submit();}}>Continue</Button></div>
                </Fragment>
              }
            </Section>
          )

  }else{

          return(
            <Section icon={(confirm_these==undefined && remaining_prospects==undefined)?null:<BackIcon onClick={()=>{setConfirmThese(undefined);}}/>} action={(current_batch_data==undefined || current_batch_data.type==2)?null:(confirm_these==undefined && remaining_prospects==undefined)?null:<Button variant='contained' onClick={()=>{cancel(current_batch)}}>Delete</Button>}>
              {(remaining_prospects==undefined)?<Typography style={{ width: '100%', textAlign: 'center', marginTop: (confirm_these === undefined && remaining_prospects === undefined) ? '18px' : '-20px', marginBottom: '40px',fontFamily: 'Arial, sans-serif',fontSize: '1.25rem',fontWeight: 500,lineHeight: '1.6',letterSpacing: '0.0075em',textTransform: 'none'}} variant='h5'><span style={{color:theme.palette.primary.main}}>Confirmation required</span><span style={{color:theme.palette.secondary.main}}>{" "+credit_cost_text}</span></Typography>
              :<Typography style={{width:'100%', textAlign:'center', marginTop:'-10px', marginBottom:'10px'}} color='secondary' variant='h5'>{"Insufficient credits"}</Typography>}
              {(confirm_these==undefined)?
                <Fragment>
                  <Typography>{(props.workspace_data.confirmations_pending.length==1)?'You recently added a batch of prospects to ProspectSafari. In order to finalise the operation, you must review your prospects and confirm whether we should scrape their websites for extra leads and information.':'You recently added '+props.workspace_data.confirmations_pending.length+' batches of prospects to ProspectSafari. In order to finalise the operation, you must review your prospects and confirm whether we should scrape their websites for extra leads and information.'}</Typography>
                  <div style={{height:'calc(100vh - 220px)'}}>
                  <GridList list_items={props.workspace_data.confirmations_pending} rowHeight={250} responsive_columns={{0:1}} component={(x)=>{
                      return(
                      <div style={{height:'100%', width:'100%', position:'relative', marginTop:'20px'}}>{
                        <Paper onClick={()=>{reviewDuplicates(x);}} style={{overflowX: 'hidden',overflowY: 'hidden',height: '220px',width: 'calc(100% - 40px)',marginLeft: '20px',position: 'relative',
                              transition: 'background-color 0.3s', // Add a transition effect
                              cursor: 'pointer', // Add a cursor style to indicate interactivity
                            }} onMouseEnter={(e) => {e.currentTarget.style.backgroundColor = '#e0e0e0'; // Change background color on hover
                            }} onMouseLeave={(e) => {e.currentTarget.style.backgroundColor = 'white'; // Reset background color when not hovering
                            }}>
                          <Typography color='primary' style={{marginTop:'10px', marginLeft:'10px'}}>{(x.type==1)?<CloudUploadIcon style={{marginRight:'10px', marginBottom:'-5px'}} color='primary'/>:<SearchIcon style={{marginRight:'10px', marginBottom:'-5px'}} color='primary'/>}{x.name}</Typography>
                          <Grid container>
                            <Grid item xs={12} sm={12}><Typography varian='caption' style={{marginLeft:'10px', marginTop:'5px'}}>{'Uploaded on: '+getDateTimeHere(x.created_at)}</Typography></Grid>
                              <Grid item xs={12} sm={12}><Typography varian='caption' style={{ marginLeft: '10px', marginTop: '10px' }}>{(x.type == 1) ? 'Total rows: ' + x.row_count : 'Total results: ' + x.row_count}{(x.type == 2 && x.row_count == 0) ?<span style={{color:'red', marginLeft:'10px'}}> Try a larger search area or better keywords. If that doesn't help, contact our team.</span>:null}</Typography></Grid>
                            <hr style={{width:'100%'}}/>
                            <Grid item xs={6} sm={6}><Typography varian='caption' style={{marginLeft:'10px'}}>{'New contacts: '+((x.contact_count==null)?0:x.contact_count)}</Typography></Grid>
                            <Grid item xs={6} sm={6}><Typography varian='caption' style={{marginLeft:'10px', cursor:'pointer'}}>{'Existing contacts: '+x.existing_contacts}</Typography></Grid>
                            {(x.type==1)?<Grid item xs={6} sm={6}><Typography varian='caption' style={{marginLeft:'10px'}}>{'Repeated contacts: '+x.repeated_contacts}</Typography></Grid>:null}
                            {(x.type==1)?<Grid item xs={6} sm={6}><Typography varian='caption' style={{marginLeft:'10px', cursor:'pointer'}}>{'Contactless rows: '+x.empty_contacts}</Typography></Grid>:null}
                            <hr style={{width:'100%'}}/>
                            <Grid item xs={6} sm={6}><Typography varian='caption' style={{marginLeft:'10px'}}>{'New companies: '+((x.company_count==null)?0:x.company_count)}</Typography></Grid>
                            <Grid item xs={6} sm={6}><Typography varian='caption' style={{marginLeft:'10px', cursor:'pointer'}}>{'Existing companies: '+x.existing_companies}</Typography></Grid>
                          </Grid>
                        </Paper>
                      }</div>
                    )}}
                  />
                  </div>
                  {(duplicates_popup==undefined)?null:<Popup always_open title={(existing_companies!=undefined)?'Existing companies':'Warnings'} content={
                    <Fragment>
                      {(existing_companies!=undefined)?<div style={{width:'600px', height:'400px'}}>
                              <div style={{width:'calc(100% -40px)', marginLeft:'20px', marginBottom:'20px', marginTop:'20px'}}><Typography color='primary'>{duplicates_popup.existing_companies+' companies already exist in your workspace. Do you wish to move them to list:"'+duplicates_popup.list.name+'"'}</Typography></div>
                              <div style={{width:'100%', height:'300px'}}><List background_colour='rgba(255,255,255,1)' small_text list_data={existing_companies}/></div>
                            </div>
                            :(confirm_duplicates==undefined)?<div style={{width:'600px', height:'400px'}}></div>:<div style={{width:'600px', height:'400px'}}>
                              <div style={{width:'calc(100% -40px)', marginLeft:'20px', marginBottom:'20px', marginTop:'20px'}}>
                                <Typography color='primary'>{'Rows missing or repeating a contact: '+(duplicates_popup.empty_contacts+duplicates_popup.repeated_contacts)}</Typography>
                              </div>
                              <div style={{width:'100%', height:'300px'}}><List background_colour='rgba(255,255,255,1)' small_text list_data={confirm_duplicates}/></div>
                            </div>}
                    </Fragment>
                  } handleClose={()=>{setDuplicatesPopup(undefined);}} accept_button_click={()=>{if(existing_companies==undefined){reviewCompanies(duplicates_popup.id);}else{listMoveDecision(duplicates_popup, true);}}} secondary_accept_button_click={()=>{listMoveDecision(duplicates_popup, false)}} accept_button={(existing_companies==undefined)?'Continue':'Move'} secondary_accept_button={(existing_companies==undefined)?undefined:"Don't move"}/>}
                </Fragment>
                :
                (confirm_these=='loading')?
                  <div style={{height:'400px', width:'100%', position:'relative'}}><Loader embed/></div>
                :
                (remaining_prospects!=undefined)?
                  <Fragment>
                  <Typography style={{width:'calc(100% - 60px)', marginLeft:'30px', textAlign:'center'}}>{"To complete this operation you will require an additional "+topups_required+" credits."}</Typography>
                  <Typography color='secondary' style={{width:'calc(100% - 60px)', marginTop:'20px', marginLeft:'30px', textAlign:'center'}}>TOPUP credits never expire and will only be used once your monthly credits are finished.</Typography>
                  <Grid container style={{marginTop:'40px', width:'calc(100% - 40px)', marginLeft:'20px'}}><Grid item xs={6} style={{display:'flex', justifyContent:'center', alignItems:'center'}}><Button variant='contained' color='secondary' onClick={()=>{window.location.href=topup_url;}}>Topup</Button></Grid><Grid item xs={6} style={{display:'flex', justifyContent:'center', alignItems:'center'}}><Button variant='contained' color='primary' onClick={()=>{window.location.href='/';}}>Go back</Button></Grid></Grid>
                  </Fragment>
                :
                <Fragment>
                {(1==0 && isJumpstartCustomer(props.workspace)==true)?<div style={{marginTop:'-30px'}}><Warning_box warning={<span>credits consumed in this operation are not the same thing as credits used for <span style={{fontWeight:'bold'}}>JumpStart phone scoring.</span></span>}/></div>:null}
                {(current_batch_data.type!=2)?null:<Warning_box warning={<span>{current_batch_data.company_count+" results were added after deduplication. You have been charged "}<span><Credit_price small service_identifier="COMPANY_GOOGLE_MAPS" quantity={current_batch_data.company_count}/></span> for this search</span>}/>}
                <Typography variant='caption' style={{marginBottom:'40px', textAlign:'center', width:'100%'}}>{"Prospects will be added to"}{(props.lists==undefined || current_batch_data==undefined)?" your account.":<b>{" List: "+props.lists[current_batch_data.list_id].name}</b>}. Should we scrape websites for insights and contact details?</Typography>
                <div style={{marginLeft:'10px', marginBottom:'-15px'}}><FormControlLabel control={<Checkbox disabled checked={(checkboxes.length==list.length)?true:false} onChange={()=>{if(checkboxes.length==list.length){setCheckboxes([]); setSecondaryCheckboxes([]);}else{let xs=[]; for(let x of list){xs.push(x.id);} setCheckboxes(xs);}}} name="include" color="primary"/>} label={<Typography color='primary'>Save prospects to prospectsafari</Typography>}/></div>
                <div style={{marginLeft:'40px', marginBottom:'-5px'}}><FormControlLabel control={<Checkbox checked={(secondary_checkboxes.length==list.length)?true:false} onChange={()=>{if(secondary_checkboxes.length==list.length){setSecondaryCheckboxes([]);}else{let xs=[]; for(let x of list){xs.push(x.id);} setSecondaryCheckboxes(xs); setCheckboxes(xs);}}} name="scrape_websites" color="secondary"/>} label={<Typography color='secondary'>Scrape websites</Typography>}/></div>
                <hr style={{width:'100%'}}/>
                <div style={{height:(isJumpstartCustomer(props.workspace)==true)?'calc(100vh - 440px)':'calc(100vh - 420px)',  width:'calc(100% + 40px)', marginLeft:'-20px', position:'relative'}}>
                      <List background_colour='rgba(255,255,255,1)' small_text list_data={list} onClick={(x)=>{console.log(x);}} disable_checkbox checkboxes={checkboxes}
                      onChange={(x)=>{let ns=[];for(let xx of secondary_checkboxes){if(x.indexOf(xx) !== -1){ns.push(xx);}} setSecondaryCheckboxes(ns); setCheckboxes(x);}} secondary_checkboxes={(scrape_websites==true)?secondary_checkboxes:[]}
                      onChangeSecondary={(x)=>{let ns=checkboxes; for(let xx of x){if(ns.indexOf(xx) === -1){ns.push(xx);}}console.log('RESULT sec', ns, x); setCheckboxes(ns); setSecondaryCheckboxes(x);}}/>
                </div>
                <div style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center', marginTop:'40px'}}><Button variant='contained' color='secondary' onClick={()=>{submit(current_batch);}}>Confirm</Button></div>
                </Fragment>
              }
            </Section>
          )
      }
}



export default connect(ss,dd)(Confirmation_required);


function ss(state){
  return{
    lists:state.lists.data,
    list_id:state.companies.list_id,
    search_name:state.companies.search_name,
    search_previews:state.companies.search_previews,
    search_batch_id:state.companies.search_batch_id,
    last_url:state.account.last_url,
  }
}

function dd(dispatch){
  return{
    index_lists:()=>{dispatch({type:'REQUEST_LIST_INDEX'});},
    setLoader:(bool)=>{dispatch({type:'REQUEST_LOADER_NOW', val:bool})},
    getPreview:(id)=>{dispatch({type:'REQUEST_AUTOMATED_SEARCH_PREVIEW', id:id})},
    automatedSearch:(data)=>{dispatch({type:'REQUEST_AUTOMATED_SEARCH', payload:data});}
  }
}







//if(previews!=undefined && previews.length==0){
//  return(<Popup always_open title={'Search: '+search} content={
//      <div style={{width:'600px', height:'300px', display:'flex', justifyContent:'center', alignItems:'center'}}>
//        <Explanation_text text='prospect_search_0_results_text'/>
//      </div>
//    } closed={()=>{trySearchAgain(preview_batch_id)}} accept_button='Try again'/>)
//}else if(previews!=undefined && previews.length>0){
//  return(
//    <Fragment>
//    <Typography style={{marginBottom:'20px', textAlign:'center', width:'100%'}}><Explanation_text text='websites_search_preview_text'/></Typography>
//    <Grid container><Grid item xs={6} style={{display:'flex', justifyContent:'center', alignItems:'center'}}><TextField disabled label="Search" value={search} onChange={setSearch}/></Grid><Grid item xs={6} style={{display:'flex', justifyContent:'center', alignItems:'center'}}><TextField label="Max results" type='number' value={max_results} onChange={(e)=>{setMaxResults(e.target.value)}}/></Grid></Grid>
//    <div style={{height:'300px', width:'calc(100% + 40px)', marginTop:'20px', marginLeft:'-20px', position:'relative'}}>
//          <List background_colour='rgba(255,255,255,1)' small_text list_data={previews}/>
//    </div>
//    <div style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center', marginTop:'40px'}}><Button variant='contained' color='secondary' onClick={()=>{setBatchWaitNotice(true)}}>Continue</Button><Button variant='contained' style={{marginLeft:'60px'}} onClick={()=>{trySearchAgain(preview_batch_id);}}>Cancel</Button></div>
//    {(batch_wait_notice==true)?<Popup always_open title='Confirm search'  accept_button_click={()=>{submitSearch(preview_batch_id);}} content={<div style={{width:'600px', height:'300px', display:'flex', justifyContent:'center', alignItems:'center'}}><Typography style={{width:'calc(100% - 40px)'}}><Explanation_text text='prospect_batch_wait_notice'/></Typography></div>} closed={()=>{setBatchWaitNotice(false);}} accept_button='Confirm'/>:null}
//    </Fragment>
//  )
//}
//else
